// extracted by mini-css-extract-plugin
export default {"container":"styles_container__PgGVv","padding":"styles_padding__a9MWt","paddingDownload":"styles_paddingDownload__N2s31"};